import React from "react";

import * as S from "./styles";

export const Slide1: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Wrapper>
          <S.Title>
            Se meu
            <br />
            apartamento
            <br />
            falasse
          </S.Title>
          <S.Text>
            <p>
              Que moletom, que nada! Em autorretratos, a fotógrafa Carine
              Wallauer curte a liberdade de se vestir para si mesma, com direito
              a tule, cores e muita estampa.
            </p>
            <p>
              Fotos <span>Carine Wallauer</span>
              <br />
              Edição de moda <span>Lucas Boccalão</span>
            </p>
            <p className="credit">
              Macacão, Irrita, R$ 985. Sandálias, Room, R$ 1.490.
            </p>
          </S.Text>
        </S.Wrapper>
        <S.Credit>Macacão, Irrita, R$ 985.</S.Credit>
      </S.Content>
    </S.Container>
  );
};
